import DatasetPlanPositioning from "@/modules/dataset-plan-positioning";
import { useInterventionSectionContext } from "@/modules/intervention/intervention-section-context";
import { useInterventionSectionDatasetPlanPositioning } from "@/modules/intervention/intervention-section-datasets";

const InterventionSectionPlanPositioning = () => {
  const { key, loading, disabled, dataset, template } =
    useInterventionSectionDatasetPlanPositioning();
  const { interventionAsset } = useInterventionSectionContext();

  return (
    <DatasetPlanPositioning
      key={key}
      disabled={disabled}
      loading={loading}
      template={template}
      dataset={dataset}
      asset={interventionAsset}
    />
  );
};

export default InterventionSectionPlanPositioning;
